import { DateFormatterOptions, UnitFormatterOptions } from "globalize";
import { DayOfWeek, Instant, LocalDate, LocalDateTime, LocalTime } from "@js-joda/core";
import { globalize } from "./translate";

export class GlobalizeExt {
  public constructor(wrap: Globalize) {
    this.globalize = wrap;
  }

  private globalize: Globalize;

  public formatUnit(value: number, unit: string, options?: UnitFormatterOptions): string {
    return this.globalize.formatUnit(value, unit, options);
  }

  /**
   * Will format the Instant in the user's local time
   */
  public formatInstant(value: Instant, options?: DateFormatterOptions): string {
    const date = new Date(value.toEpochMilli());
    return this.globalize.formatDate(date, options);
  }

  public formatLocalDateTime(value: LocalDateTime, options?: DateFormatterOptions): string {
    const date = new Date(
      value.year(),
      value.monthValue() - 1,
      value.dayOfMonth(),
      value.hour(),
      value.minute(),
      value.second(),
      Math.floor(value.nano() / 1000000)
    );
    return this.globalize.formatDate(date, options);
  }

  public formatLocalDate(value: LocalDate, options?: DateFormatterOptions): string {
    const date = new Date(value.year(), value.monthValue() - 1, value.dayOfMonth());
    return this.globalize.formatDate(date, options);
  }

  /**
   * @param options Should use "time" key with value either "short" or "medium"
   */
  public formatLocalTime(value: LocalTime, options?: DateFormatterOptions): string {
    const date = new Date(
      2000,
      0,
      1,
      value.hour(),
      value.minute(),
      value.second(),
      Math.floor(value.nano() / 1000000)
    );
    return this.globalize.formatDate(date, options);
  }

  public formatDayOfWeek(value: DayOfWeek, short: boolean): string {
    // <https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md#optionsraw>
    // <http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table>

    const pattern = short ? "EEE" : "EEEE";

    // January 1, 2006 is a Sunday
    return globalize().formatLocalDateTime(LocalDateTime.of(2006, 1, 2 + value.ordinal()), {
      raw: pattern,
    });
  }
}
